import React, { useRef, useContext, useState, useEffect } from "react";
import { CameraSection } from "../../context/CameraContext";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FiX, FiCheck, FiCamera, FiLink, FiArrowLeft, FiTrash2 } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const EditCamera = () => {
  const { t } = useTranslation();
  const { CameraShowHideFunc, selectedCamera } = useContext(CameraSection);
  let form = useRef();

  const initialValues = {
    address: selectedCamera?.address || "",
    name: selectedCamera?.name || "",
  };

  const validationSchema = Yup.object({
    address: Yup.string().required(t("آدرس دوربین را وارد کنید.")),
    name: Yup.string().required(t("نام دوربین را وارد کنید.")),
  });

  const submitForm = (values) => {
    console.log("Update:", values);
    // اینجا کد ویرایش دوربین
    CameraShowHideFunc("firstPage");
  };

  const handleDelete = () => {
    if (window.confirm(t("آیا از حذف این دوربین اطمینان دارید؟"))) {
      console.log("Delete camera");
      CameraShowHideFunc("firstPage");
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitForm}
      validationSchema={validationSchema}
    >
      {(formProps) => (
        <Form ref={form}>
          {/* Camera Address Field */}
          <div className="camera-form-group">
            <label className="camera-form-label">
              <FiLink size={16} />
              <span>{t("آدرس دوربین")}</span>
            </label>
            <input
              type="text"
              placeholder="http://example.com"
              name="address"
              className="camera-form-input"
              onChange={formProps.handleChange}
              onBlur={formProps.handleBlur}
              value={formProps.values.address}
            />
            <ErrorMessage name="address">
              {(errMsg) => <div className="setting-error">{errMsg}</div>}
            </ErrorMessage>
          </div>

          {/* Camera Name Field */}
          <div className="camera-form-group">
            <label className="camera-form-label">
              <FiCamera size={16} />
              <span>{t("نام دوربین")}</span>
            </label>
            <input
              type="text"
              placeholder={t("نام دوربین")}
              name="name"
              className="camera-form-input"
              onChange={formProps.handleChange}
              onBlur={formProps.handleBlur}
              value={formProps.values.name}
            />
            <ErrorMessage name="name">
              {(errMsg) => <div className="setting-error">{errMsg}</div>}
            </ErrorMessage>
          </div>

          {/* Action Buttons */}
          <div className="setting-buttons">
            <button
              type="button"
              className="setting-back-btn"
              onClick={handleDelete}
              style={{ background: "rgba(245, 101, 101, 0.1)", color: "#f56565", border: "2px solid #f56565" }}
            >
              <FiTrash2 size={18} />
              <span>{t("حذف")}</span>
            </button>
            <button
              type="button"
              className="setting-back-btn"
              onClick={() => CameraShowHideFunc("firstPage")}
              style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
            >
              <FiArrowLeft size={18} />
              <span>{t("انصراف")}</span>
            </button>
            <button type="submit" className="setting-back-btn">
              <FiCheck size={18} />
              <span>{t("ذخیره")}</span>
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export { EditCamera };